import logger from 'utils/logger';

import { extractNameAndFileType, isBase64 } from '..';
import { DownloadFileFromUrlProps } from '../../types';

export const downloadFileFromUrl = async ({ url }: DownloadFileFromUrlProps) => {
  if (isBase64(url)) {
    const { fileNameWithExtension } = extractNameAndFileType(url);

    if (!fileNameWithExtension) {
      return;
    }

    // The following line is to handle the case where the URL has query parameters
    // that might interfere with the file name.
    // For example, if the URL is "https://example.com/file.jpeg?param=value",
    // we want to extract "file.jpeg" as the file name.
    let finalFileName = fileNameWithExtension;
    if (fileNameWithExtension.includes('?')) {
      finalFileName = fileNameWithExtension.split('?')[0];
    }

    try {
      const response = await fetch(url, { mode: 'no-cors' });

      if (!response.ok) {
        return;
      }

      const data = await response.blob();
      const urlBlob = window.URL.createObjectURL(data);
      // Create a temporary anchor element and trigger the download
      const a = document.createElement('a');
      a.href = urlBlob;
      a.download = finalFileName || 'download';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      logger.error({ error, message: 'Failed to download file from campaign on web' });
    }
  } else {
    window.open(url, 'blank');
  }
};
